import React from 'react';

interface LandingPageProps {
  onContinue: () => void;
}

const LandingPage: React.FC<LandingPageProps> = ({ onContinue }) => {
  return (
    <div className="landing-page">
      <h1>Delete Your XETA Account and Personal Data</h1>
      <div className="warning-content">
        <p>This will permanently delete your XETA account and all associated personal data</p>
        <ul>
          <li>
            Your WiFi router configurations, network settings, and device information will be
            removed
          </li>
          <li>This action cannot be undone and will terminate your XETA service</li>
          <li>Some accounting records may be retained as required by law</li>
        </ul>
      </div>
      <button onClick={onContinue} className="continue-button">
        Continue
      </button>
    </div>
  );
};

export default LandingPage;
